<template>
  <div class="repository-warp">
    <div class="repository-content">
      <div class="search-warp">
        <el-input v-model="titleInput" size="small" style="width: 160px;" placeholder="请输入标题"></el-input>
        <el-button type="primary" size="small" style="margin-left:14px" @click="getData">查询</el-button>
        <el-button type="primary" size="small" @click="showAdd">新增知识项</el-button>
      </div>
      <div class="table-warp">
        <nk-table :columns="columns" :data="tableData" :showPage="false">
          <el-table-column label="操作" :align="'center'" width="120">
            <template slot-scope="scope">
              <el-button type="text" @click="showEdit(scope.$index, scope.row)">编辑</el-button>
              <el-button type="text" @click="del(scope.$index, scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </nk-table>
      </div>

      <lt-msg-box :visible="visible" @cancel="visible = false" @confirm="saveAdd" :title="'新增知识项'" :width="'500px'">
        <div class="form-container">
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="80px" class="demo-ruleForm">
            <el-form-item label="标题" prop="title">
              <el-input type="textarea" maxlength="128" show-word-limit v-model="ruleForm.title"></el-input>
            </el-form-item>
            <el-form-item label="内容" prop="content">
              <el-input type="textarea" class="rows-content" maxlength="512" show-word-limit v-model="ruleForm.content"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </lt-msg-box>

      <lt-msg-box :visible="editVisible" @cancel="editVisible = false" @confirm="saveEdit" :title="'修改知识项'" :width="'500px'">
        <div class="form-container">
          <el-form :model="editForm" :rules="editRules" ref="editForm" label-width="80px" class="demo-ruleForm">
            <el-form-item label="标题" prop="title">
              <el-input type="textarea" maxlength="128" show-word-limit v-model="editForm.title"></el-input>
            </el-form-item>
            <el-form-item label="内容" prop="content">
              <el-input type="textarea" class="rows-content" maxlength="512" show-word-limit v-model="editForm.content"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </lt-msg-box>
    </div>
  </div>
</template>

<script>

import NkTable from '@/components/common/NkTable.vue'
import LtMsgBox from '@/components/common/LtMsgBox.vue';
import api from '../../../../../common/api'
export default {
  components: { NkTable, LtMsgBox },
  data () {
    return {
      companyId: 0,
      titleInput: '',
      columns: [
        { prop: 'title', label: '标题', width: '300', show: true },
        { prop: 'content', label: '内容', show: true },
      ],
      tableData: [],
      visible: false,
      ruleForm: { title: '', content: '' },
      rules: {
        title: [
          { required: true, message: '请输入标题', trigger: 'blur' },
        ],
        content: [
          { required: true, message: '请输入内容', trigger: 'blur' },
        ],
      },
      editVisible: false,
      editForm: {},
      editRules: {
        title: [
          { required: true, message: '请输入标题', trigger: 'blur' },
        ],
        content: [
          { required: true, message: '请输入内容', trigger: 'blur' },
        ],
      },
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    getData () {
      let vm = this
      const companyId = vm.companyId
      api.electricOperations.getKnowledgeBase(companyId).then(res => {
        let tableData = []
        if (res.data) {
          for (let i = 0; i < res.data.length; i++) {
            if (res.data[i].title.indexOf(vm.titleInput) > -1) {
              tableData.push(res.data[i])
            }
          }
        }
        vm.tableData = tableData
      })
    },
    showAdd () {
      let vm = this
      vm.visible = true
      vm.ruleForm = {
        title: '',
        content: '',
        companyId: vm.companyId
      }
    },
    saveAdd () {
      let vm = this
      this.$refs["ruleForm"].validate((valid) => {
        const { title, content, companyId } = vm.ruleForm

        api.electricOperations.addKnowledgeBase(companyId, content, title).then(res => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '添加成功!'
            });
            vm.visible = false
            vm.getData()
          }
        })
      })
    },
    showEdit (index, row) {
      let vm = this

      vm.editForm = JSON.parse(JSON.stringify(row))
      vm.editForm.index = index
      vm.editVisible = true
    },
    saveEdit () {
      let vm = this
      this.$refs["editForm"].validate((valid) => {
        const { title, content, companyId, index, id } = vm.editForm

        api.electricOperations.updateKnowledgeBase(companyId, content, id, title).then(res => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '修改成功!'
            });
            vm.editVisible = false
            vm.getData()
          }
        })
      })
    },
    del (index, row) {
      let vm = this
      this.$confirm('此操作将永久删除该知识项, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        api.electricOperations.deleteKnowledgeBase(row.id).then(res => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            vm.tableData.splice(index, 1)
          }
        })
      }).catch(() => {
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.repository-warp {
  width: 100%;
  height: 100%;
  padding: 14px;
  box-sizing: border-box;
  .repository-content {
    width: 100%;
    height: 100%;
    padding: 14px;
    box-sizing: border-box;
    background: #fff;
    display: flex;
    flex-flow: column;
    text-align: left;

    .search-warp {
      padding-bottom: 14px;
    }
    .table-warp {
      flex: 1;
      overflow: hidden;
    }
    .form-container {
      padding: 0px 14px;
    }
  }
}
</style>
<style lang="scss">
.rows-content {
  .el-textarea__inner {
    min-height: 240px !important;
  }
}
</style>